import type { Editor } from "grapesjs";

export function registerMarksheetBlocks(editor: Editor) {
  const bm = editor.BlockManager;

  // ── Layout blocks ──────────────────────────────────────────────────────────

  bm.add("ms-page", {
    label: "A4 Page",
    category: "Marksheet",
    content: `<div class="ms-page"><div class="ms-content"></div></div>`,
  });

  bm.add("ms-board-header", {
    label: "School Header",
    category: "Marksheet",
    content: `
      <div class="ms-board-header">
        <div class="ms-school-name">{{school.name}}</div>
        <div class="ms-exam-title">{{exam.type}} {{session.year}}</div>
        <div class="ms-dise">DISE CODE: {{school.diseCode}}</div>
      </div>`,
  });

  bm.add("ms-student-section", {
    label: "Student Info",
    category: "Marksheet",
    content: `
      <div class="ms-student-wrap">
        <div class="ms-student-row">
          <div class="ms-student-lines">
            <div class="ms-student-line">STUDENT'S NAME: {{student.name}}</div>
            <div class="ms-student-line">FATHER'S NAME: {{student.fatherName}}</div>
            <div class="ms-student-line">MOTHER'S NAME: {{student.motherName}}</div>
            <div class="ms-student-line">DATE OF BIRTH: {{student.dob}}</div>
            <div class="ms-student-line">CLASS: {{student.class}}</div>
          </div>
          <div class="ms-photo-wrap">
            <div class="ms-photo-box">PHOTO</div>
          </div>
        </div>
      </div>`,
  });

  bm.add("ms-marks-table", {
    label: "Marks Table",
    category: "Marksheet",
    content: `<div class="ms-marks-table-token">{{marksTable}}</div>`,
  });

  bm.add("ms-summary-row", {
    label: "Summary Row",
    category: "Marksheet",
    content: `
      <table class="ms-table">
        <tbody>
          <tr>
            <th>PERCENTAGE</th>
            <th>TOTAL GRADE</th>
            <th>RESULT</th>
            <th>RANK</th>
            <th>FAIL SUBJECT</th>
          </tr>
          <tr>
            <td>{{marksheet.percentage}}%</td>
            <td>{{marksheet.totalGrade}}</td>
            <td>{{marksheet.result}}</td>
            <td>{{marksheet.rank}}</td>
            <td>{{marksheet.failSubjects}}</td>
          </tr>
        </tbody>
      </table>`,
  });

  bm.add("ms-signature-row", {
    label: "Signature Row",
    category: "Marksheet",
    content: `
      <div class="ms-signatures">
        <div class="ms-sign">CLASS TEACHER</div>
        <div class="ms-sign">PRINCIPAL</div>
      </div>`,
  });

  // ── Token blocks (drag onto canvas to insert a single token) ───────────────

  bm.add("ms-student-photo", {
    label: "Student Photo",
    category: "Marksheet",
    content: `
      <div class="ms-photo-wrap">
        <div class="ms-photo-box">{{student.photo}}</div>
      </div>`,
  });

  const tokens: Array<{ id: string; label: string; token: string }> = [
    { id: "ms-tok-school-name",    label: "School Name",     token: "{{school.name}}" },
    { id: "ms-tok-school-code",    label: "School Code",     token: "{{school.code}}" },
    { id: "ms-tok-dise-code",      label: "DISE Code",       token: "{{school.diseCode}}" },
    { id: "ms-tok-exam-type",      label: "Exam Type",       token: "{{exam.type}}" },
    { id: "ms-tok-session-year",   label: "Session Year",    token: "{{session.year}}" },
    { id: "ms-tok-student-name",   label: "Student Name",    token: "{{student.name}}" },
    { id: "ms-tok-roll-no",        label: "Roll No",         token: "{{student.rollNo}}" },
    { id: "ms-tok-enrollment-no",  label: "Enrollment No",   token: "{{student.enrollmentNo}}" },
    { id: "ms-tok-father-name",    label: "Father Name",     token: "{{student.fatherName}}" },
    { id: "ms-tok-mother-name",    label: "Mother Name",     token: "{{student.motherName}}" },
    { id: "ms-tok-dob",            label: "Date of Birth",   token: "{{student.dob}}" },
    { id: "ms-tok-class",          label: "Class",           token: "{{student.class}}" },
    { id: "ms-tok-percentage",     label: "Percentage",      token: "{{marksheet.percentage}}" },
    { id: "ms-tok-total-grade",    label: "Total Grade",     token: "{{marksheet.totalGrade}}" },
    { id: "ms-tok-result",         label: "Result",          token: "{{marksheet.result}}" },
    { id: "ms-tok-rank",           label: "Rank",            token: "{{marksheet.rank}}" },
    { id: "ms-tok-fail-subjects",  label: "Fail Subjects",   token: "{{marksheet.failSubjects}}" },
  ];

  for (const t of tokens) {
    bm.add(t.id, {
      label: t.label,
      category: "Tokens",
      content: `<span class="ms-token">${t.token}</span>`,
    });
  }
}
